<template>
  <div class="Abstractted">
    <!-- 当前位置 -->
    <div class="box">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <span class="dangqian">当前位置：</span>
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <div class="red">系统简介</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <!-- 左侧 -->
      <div class="left">
        <div class="top">
          <i class="iconfont iconbianzu10beifen3"></i>
          <p class="yi">系统简介</p>
        </div>
      </div>
      <div class="right">
        <div class="sys" v-for="item in list" :key="item.id">
          <h4>{{ item.tip }}</h4>
          <p class="er">{{ item.content }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.getSys();
  },
  methods: {
    getSys() {
      this.Api.getSys().then((res) => {
        if (res.code == 0) {
          console.log(res);
          this.list = res.data;
        }
      });
    },
  },
  data() {
    return {
      // 系统列表
      list: [],
    };
  },
};
</script>

<style lang="less" scoped>
p {
  color: #666666;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 25px;
}
.container {
  width: 1200px;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 0 auto;
  margin-top: 20px;
}
h4 {
  color: #333333;
  font-size: 18px;
}
.Abstractted {
  background: #f2f2f2;
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 40px;
}

.box {
  margin-top: 15px;
  width: 100%;
  height: 12px;
}
/deep/ .el-breadcrumb {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  line-height: 12px;
  float: left;
}
.dangqian {
  float: left;
}
/deep/.el-breadcrumb__inner {
  font-weight: 400 !important;
}
.red {
  color: #00345e;
}

.left {
  width: 180px;
  height: 110px;
  background-color: white;
}

.top {
  margin-top: 24px;
  margin-bottom: 30px;
  width: 180px;
  height: 52px;
  line-height: 52px;
  display: flex;
  justify-content: flex-start;
  background-color: #00345e;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.yi {
  margin-left: 10px;
  line-height: 34px;
  color: white;
}
.right {
  margin-left: 20px;
  width: 1000px;
  min-height: 712px;
  background-color: white;
  box-sizing: border-box;
  padding: 26px 40px;
}
i {
  margin-left: 10px;
  width: 18px;
  height: 18px;
  color: white;
}
.er {
  width: 920px;
  overflow-wrap: break-word;
}
</style>
